module.exports.CustomIcon = {
  "DEUTSCHE_BAHN": "Deutsche_Bahn",
  "APPLE_WALLET_EN": "apple-wallet-en",
  "APPLE_WALLET_FI": "apple-wallet-fi",
  "AVIOS_KEYLINE_NAVY": "avios-keyline-navy",
  "AVIOS_KEYLINE_WHITE": "avios-keyline-white",
  "AVIOS_SMALL_USE_NAVY": "avios-small-use-navy",
  "AVIOS_SMALL_USE_WHITE": "avios-small-use-white",
  "BA_CLUB": "ba-club",
  "BAEC_EMBLEM": "baec-emblem",
  "BAEC_LOGO": "baec-logo",
  "BUSINESS_BASSINET_SEAT": "business-bassinet-seat",
  "CARTRAWLER_LOGO": "cartrawler-logo",
  "COMFORT_SEAT": "comfort-seat",
  "ECONOMY_BASSINET_SEAT": "economy-bassinet-seat",
  "EXIT_ROW_SEAT": "exit-row-seat",
  "EXTRA_LEGROOM_SEAT": "extra-legroom-seat",
  "FINNAIR_EMBLEM": "finnair-emblem",
  "FINNAIR_LOGO_100": "finnair-logo-100",
  "FINNAIR_LOGO_PLUS": "finnair-logo-plus",
  "FINNAIR_LOGO": "finnair-logo",
  "FRONT_ROW_SEAT": "front-row-seat",
  "GOOGLE_WALLET_EN": "google-wallet-en",
  "GOOGLE_WALLET_FI": "google-wallet-fi",
  "HOTELS_LOGO": "hotels-logo",
  "PLUS_CARD_BASIC_BG": "plus-card-basic-bg",
  "PLUS_CARD_BASIC": "plus-card-basic",
  "PLUS_CARD_GOLD_BG": "plus-card-gold-bg",
  "PLUS_CARD_GOLD": "plus-card-gold",
  "PLUS_CARD_JUNIOR_BG": "plus-card-junior-bg",
  "PLUS_CARD_JUNIOR": "plus-card-junior",
  "PLUS_CARD_LUMO_BG": "plus-card-lumo-bg",
  "PLUS_CARD_LUMO": "plus-card-lumo",
  "PLUS_CARD_PLATINUM_BG": "plus-card-platinum-bg",
  "PLUS_CARD_PLATINUM": "plus-card-platinum",
  "PLUS_CARD_SILVER_BG": "plus-card-silver-bg",
  "PLUS_CARD_SILVER": "plus-card-silver",
  "PLUS_ICON_BASIC": "plus-icon-basic",
  "PLUS_ICON_GOLD": "plus-icon-gold",
  "PLUS_ICON_LUMO": "plus-icon-lumo",
  "PLUS_ICON_PLATINUM": "plus-icon-platinum",
  "PLUS_ICON_SILVER": "plus-icon-silver",
  "PREFERRED_SEAT": "preferred-seat",
  "PREMIUM_BASSINET_SEAT": "premium-bassinet-seat",
  "PREMIUM_SEAT": "premium-seat",
  "REGULAR_SEAT": "regular-seat",
  "SELECTED_SEAT": "selected-seat",
  "UNAVAILABLE_SEAT": "unavailable-seat"
};

module.exports.PaymentsIcon = {
  "ADYENPAYMENTCARD": "adyenpaymentcard",
  "AKTIA": "aktia",
  "ALANDSBANKEN": "alandsbanken",
  "ALIPAY": "alipay",
  "AMEX": "amex",
  "APPLEPAY": "applepay",
  "ARBEJDERNES": "arbejdernes",
  "BARCLAYS": "barclays",
  "CITADELE": "citadele",
  "COOPPANK": "cooppank",
  "DANSKEBANK": "danskebank",
  "DINERSCLUB": "dinersclub",
  "DISCOVER": "discover",
  "DNB": "dnb",
  "GIROPAY": "giropay",
  "HANDELSBANKEN": "handelsbanken",
  "HSBCUK": "hsbcuk",
  "IDEAL": "ideal",
  "INDIANETBANKING": "indianetbanking",
  "INDIAWALLET": "indiawallet",
  "JCB": "jcb",
  "JYSKEBANK": "jyskebank",
  "KLARNA": "klarna",
  "LANSFORSAKRINGAR": "lansforsakringar",
  "LHVPANK": "lhvpank",
  "LLOYDSBANK": "lloydsbank",
  "LUMINOR": "luminor",
  "LUNARBANK": "lunarbank",
  "MASTERCARD": "mastercard",
  "MOBILEPAY": "mobilepay",
  "NATWEST": "natwest",
  "NORDEA": "nordea",
  "NYKREDITBANK": "nykreditbank",
  "OMASP": "omasp",
  "OP": "op",
  "PAYPAL": "paypal",
  "POPPANKKI": "poppankki",
  "REVOLUT": "revolut",
  "RUPAY": "rupay",
  "SAASTOPANKKI": "saastopankki",
  "SANTANDERUK": "santanderuk",
  "SBANKEN": "sbanken",
  "SEB": "seb",
  "SOFORT": "sofort",
  "SPANKKI": "spankki",
  "SPAREBANK1NO": "sparebank1no",
  "SPAREBANK1SM": "sparebank1sm",
  "SPAREBANKOST": "sparebankost",
  "SWEDBANK": "swedbank",
  "SWISH": "swish",
  "TRUSTLY": "trustly",
  "UATP": "uatp",
  "UNIONPAY": "unionpay",
  "UPI": "upi",
  "VIPPS": "vipps",
  "VISA": "visa",
  "WECHATPAY": "wechatpay"
};

module.exports.SvgLibraryIcon = {
  "ADULT_INFANT_BLOCK": "adult-infant-block",
  "ADULT_INFANT_OUTLINE": "adult-infant-outline",
  "ADULT_INFANT": "adult-infant",
  "AIRCRAFT_HORIZONTAL_BLOCK": "aircraft-horizontal-block",
  "AIRCRAFT_HORIZONTAL_OUTLINE": "aircraft-horizontal-outline",
  "AIRCRAFT_HORIZONTAL": "aircraft-horizontal",
  "AIRCRAFT_TILTED_BLOCK": "aircraft-tilted-block",
  "AIRCRAFT_TILTED_OUTLINE": "aircraft-tilted-outline",
  "AIRCRAFT_TILTED": "aircraft-tilted",
  "AIRCRAFT_VERTICAL_BLOCK": "aircraft-vertical-block",
  "AIRCRAFT_VERTICAL_OUTLINE": "aircraft-vertical-outline",
  "AIRCRAFT_VERTICAL": "aircraft-vertical",
  "AIRPORT_BLOCK": "airport-block",
  "AIRPORT_OUTLINE": "airport-outline",
  "AIRPORT": "airport",
  "ALERT_BLOCK": "alert-block",
  "ALERT_OUTLINE": "alert-outline",
  "ALERT_TRIANGLE": "alert-triangle",
  "ALERT": "alert",
  "AM_LOGO": "am-logo",
  "AREA_MAP_BLOCK": "area-map-block",
  "AREA_MAP_OUTLINE": "area-map-outline",
  "AREA_MAP": "area-map",
  "ARRIVAL_BLOCK": "arrival-block",
  "ARRIVAL_OUTLINE": "arrival-outline",
  "ARRIVAL": "arrival",
  "ARROW_BACK_BLOCK": "arrow-back-block",
  "ARROW_BACK_OUTLINE": "arrow-back-outline",
  "ARROW_BACK": "arrow-back",
  "ARROW_DOWN_BLOCK": "arrow-down-block",
  "ARROW_DOWN_OUTLINE": "arrow-down-outline",
  "ARROW_DOWN": "arrow-down",
  "ARROW_LEFT_BLOCK": "arrow-left-block",
  "ARROW_LEFT_OUTLINE": "arrow-left-outline",
  "ARROW_LEFT": "arrow-left",
  "ARROW_RIGHT_BLOCK": "arrow-right-block",
  "ARROW_RIGHT_OUTLINE": "arrow-right-outline",
  "ARROW_RIGHT": "arrow-right",
  "ARROW_UP_BLOCK": "arrow-up-block",
  "ARROW_UP_OUTLINE": "arrow-up-outline",
  "ARROW_UP": "arrow-up",
  "ATTACHMENT_BLOCK": "attachment-block",
  "ATTACHMENT_OUTLINE": "attachment-outline",
  "ATTACHMENT": "attachment",
  "AVIOS_CURRENCY": "avios-currency",
  "AVIOS_GIFT_CARD_BLOCK": "avios-gift-card-block",
  "AVIOS_GIFT_CARD_OUTLINE": "avios-gift-card-outline",
  "AVIOS_GIFT_CARD": "avios-gift-card",
  "AVIOS_MONO": "avios-mono",
  "AVIOS_PLECTRUM": "avios-plectrum",
  "B2B_BLOCK": "b2b-block",
  "B2B_OUTLINE": "b2b-outline",
  "B2B": "b2b",
  "BABY_BASSINET_BLOCK": "baby-bassinet-block",
  "BABY_BASSINET_OUTLINE": "baby-bassinet-outline",
  "BABY_BASSINET": "baby-bassinet",
  "BACKPACK_BLOCK": "backpack-block",
  "BACKPACK_OUTLINE": "backpack-outline",
  "BACKPACK": "backpack",
  "BAGGAGE_CHECKED_IN_BLOCK": "baggage-checked-in-block",
  "BAGGAGE_CHECKED_IN_OUTLINE": "baggage-checked-in-outline",
  "BAGGAGE_CHECKED_IN": "baggage-checked-in",
  "BAGGAGE_CLAIM_BLOCK": "baggage-claim-block",
  "BAGGAGE_CLAIM_OUTLINE": "baggage-claim-outline",
  "BAGGAGE_CLAIM": "baggage-claim",
  "BAGGAGE_WEIGHT_BLOCK": "baggage-weight-block",
  "BAGGAGE_WEIGHT_OUTLINE": "baggage-weight-outline",
  "BAGGAGE_WEIGHT": "baggage-weight",
  "BAGGAGE_WITH_TAG_BLOCK": "baggage-with-tag-block",
  "BAGGAGE_WITH_TAG_OUTLINE": "baggage-with-tag-outline",
  "BAGGAGE_WITH_TAG": "baggage-with-tag",
  "BEER_BLOCK": "beer-block",
  "BEER_OUTLINE": "beer-outline",
  "BEER": "beer",
  "BIKE_BLOCK": "bike-block",
  "BIKE_OUTLINE": "bike-outline",
  "BIKE": "bike",
  "BLOG_BLOCK": "blog-block",
  "BLOG_OUTLINE": "blog-outline",
  "BLOG": "blog",
  "BLUEBERRY_JUICE_BLOCK": "blueberry-juice-block",
  "BLUEBERRY_JUICE_OUTLINE": "blueberry-juice-outline",
  "BLUEBERRY_JUICE": "blueberry-juice",
  "BOOK_FLIGHT_BLOCK": "book-flight-block",
  "BOOK_FLIGHT_OUTLINE": "book-flight-outline",
  "BOOK_FLIGHT": "book-flight",
  "BREAKFAST_BLOCK": "breakfast-block",
  "BREAKFAST_OUTLINE": "breakfast-outline",
  "BREAKFAST": "breakfast",
  "BRIGHTNESS_BLOCK": "brightness-block",
  "BRIGHTNESS_LOW_BLOCK": "brightness-low-block",
  "BRIGHTNESS_LOW_OUTLINE": "brightness-low-outline",
  "BRIGHTNESS_LOW": "brightness-low",
  "BRIGHTNESS_MEDIUM_BLOCK": "brightness-medium-block",
  "BRIGHTNESS_MEDIUM_OUTLINE": "brightness-medium-outline",
  "BRIGHTNESS_MEDIUM": "brightness-medium",
  "BRIGHTNESS_OUTLINE": "brightness-outline",
  "BRIGHTNESS": "brightness",
  "BUS_BLOCK": "bus-block",
  "BUS_OUTLINE": "bus-outline",
  "BUS": "bus",
  "BUSINESS_CLASS_BLOCK": "business-class-block",
  "BUSINESS_CLASS_OUTLINE": "business-class-outline",
  "BUSINESS_CLASS": "business-class",
  "CALENDAR_BLOCK": "calendar-block",
  "CALENDAR_OUTLINE": "calendar-outline",
  "CALENDAR": "calendar",
  "CAMERA_BLOCK": "camera-block",
  "CAMERA_OUTLINE": "camera-outline",
  "CAMERA": "camera",
  "CAR_BLOCK": "car-block",
  "CAR_OUTLINE": "car-outline",
  "CAR": "car",
  "CARGO": "cargo",
  "CARRY_ON_BAG_BLOCK": "carry-on-bag-block",
  "CARRY_ON_BAG_OUTLINE": "carry-on-bag-outline",
  "CARRY_ON_BAG_TROLLEY_BLOCK": "carry-on-bag-trolley-block",
  "CARRY_ON_BAG_TROLLEY_OUTLINE": "carry-on-bag-trolley-outline",
  "CARRY_ON_BAG_TROLLEY": "carry-on-bag-trolley",
  "CARRY_ON_BAG": "carry-on-bag",
  "CARRY_ON_BAGGAGE_BLOCK": "carry-on-baggage-block",
  "CARRY_ON_BAGGAGE_OUTLINE": "carry-on-baggage-outline",
  "CARRY_ON_BAGGAGE": "carry-on-baggage",
  "CARRY_ON_PROHIBITED": "carry-on-prohibited",
  "CHAT_BLOCK": "chat-block",
  "CHAT_OUTLINE": "chat-outline",
  "CHAT": "chat",
  "CHECK_IN_BLOCK": "check-in-block",
  "CHECK_IN_OUTLINE": "check-in-outline",
  "CHECK_IN": "check-in",
  "CHECKBOX_SELECTED_INVERTED": "checkbox-selected-inverted",
  "CHECKBOX_SELECTED": "checkbox-selected",
  "CHECKBOX_UNSELECTED_INVERTED": "checkbox-unselected-inverted",
  "CHECKBOX_UNSELECTED": "checkbox-unselected",
  "CHECKED_BAG_PROHIBITED": "checked-bag-prohibited",
  "CHECKED_BAGGAGE_BLOCK": "checked-baggage-block",
  "CHECKED_BAGGAGE_OUTLINE": "checked-baggage-outline",
  "CHECKED_BAGGAGE": "checked-baggage",
  "CHECKED_IN_BAGGAGE_BLOCK": "checked-in-baggage-block",
  "CHECKED_IN_BAGGAGE_NONE_BLOCK": "checked-in-baggage-none-block",
  "CHECKED_IN_BAGGAGE_NONE_OUTLINE": "checked-in-baggage-none-outline",
  "CHECKED_IN_BAGGAGE_NONE": "checked-in-baggage-none",
  "CHECKED_IN_BAGGAGE_OUTLINE": "checked-in-baggage-outline",
  "CHECKED_IN_BAGGAGE": "checked-in-baggage",
  "CHECKLIST_BLOCK": "checklist-block",
  "CHECKLIST_OUTLINE": "checklist-outline",
  "CHECKLIST": "checklist",
  "CHECKMARK_BLOCK": "checkmark-block",
  "CHECKMARK_BUTTON_SELECTED": "checkmark-button-selected",
  "CHECKMARK_BUTTON_UNSELECTED": "checkmark-button-unselected",
  "CHECKMARK_OUTLINE": "checkmark-outline",
  "CHECKMARK": "checkmark",
  "CHEVRON_DOWN_BLOCK": "chevron-down-block",
  "CHEVRON_DOWN_OUTLINE": "chevron-down-outline",
  "CHEVRON_DOWN": "chevron-down",
  "CHEVRON_LEFT_BLOCK": "chevron-left-block",
  "CHEVRON_LEFT_OUTLINE": "chevron-left-outline",
  "CHEVRON_LEFT": "chevron-left",
  "CHEVRON_RIGHT_BLOCK": "chevron-right-block",
  "CHEVRON_RIGHT_OUTLINE": "chevron-right-outline",
  "CHEVRON_RIGHT": "chevron-right",
  "CHEVRON_UP_BLOCK": "chevron-up-block",
  "CHEVRON_UP_OUTLINE": "chevron-up-outline",
  "CHEVRON_UP": "chevron-up",
  "CHILD_BLOCK": "child-block",
  "CHILD_OUTLINE": "child-outline",
  "CHILD": "child",
  "CLOCK": "clock",
  "CLOSE_DELETE_BLOCK": "close-delete-block",
  "CLOSE_DELETE_OUTLINE": "close-delete-outline",
  "CLOSE_DELETE": "close-delete",
  "CO2_BLOCK": "co2-block",
  "CO2_OUTLINE": "co2-outline",
  "CO2": "co2",
  "COFFEE_BLOCK": "coffee-block",
  "COFFEE_OUTLINE": "coffee-outline",
  "COFFEE": "coffee",
  "CONNECTING_FLIGHT_BLOCK": "connecting-flight-block",
  "CONNECTING_FLIGHT_OUTLINE": "connecting-flight-outline",
  "CONNECTING_FLIGHT": "connecting-flight",
  "COPY_BLOCK": "copy-block",
  "COPY_OUTLINE": "copy-outline",
  "COPY": "copy",
  "CORPORATE_BOOKING_BLOCK": "corporate-booking-block",
  "CORPORATE_BOOKING_OUTLINE": "corporate-booking-outline",
  "CORPORATE_BOOKING": "corporate-booking",
  "CORROSIVES_PROHIBITED": "corrosives-prohibited",
  "CORROSIVES": "corrosives",
  "COUPLE_BLOCK": "couple-block",
  "COUPLE_OUTLINE": "couple-outline",
  "COUPLE": "couple",
  "CREDIT_OR_DEBIT_CARD_BLOCK": "credit-or-debit-card-block",
  "CREDIT_OR_DEBIT_CARD_OUTLINE": "credit-or-debit-card-outline",
  "CREDIT_OR_DEBIT_CARD": "credit-or-debit-card",
  "CREW_CALLED_BLOCK": "crew-called-block",
  "CREW_CALLED_OUTLINE": "crew-called-outline",
  "CREW_CALLED": "crew-called",
  "CURRENCY_BLOCK": "currency-block",
  "CURRENCY_OUTLINE": "currency-outline",
  "CURRENCY": "currency",
  "CUSTOMER_SERVICE_BLOCK": "customer-service-block",
  "CUSTOMER_SERVICE_OUTLINE": "customer-service-outline",
  "CUSTOMER_SERVICE": "customer-service",
  "DAY_BLOCK": "day-block",
  "DAY_OUTLINE": "day-outline",
  "DAY": "day",
  "DEPARTURE_BLOCK": "departure-block",
  "DEPARTURE_GATE_BLOCK": "departure-gate-block",
  "DEPARTURE_GATE_OUTLINE": "departure-gate-outline",
  "DEPARTURE_GATE": "departure-gate",
  "DEPARTURE_OUTLINE": "departure-outline",
  "DEPARTURE": "departure",
  "DESTINATION_BLOCK": "destination-block",
  "DESTINATION_OUTLINE": "destination-outline",
  "DESTINATION": "destination",
  "DISCOUNT": "discount",
  "DISCOUNTED_PRICE_BLOCK": "discounted-price-block",
  "DISCOUNTED_PRICE_OUTLINE": "discounted-price-outline",
  "DISCOUNTED_PRICE": "discounted-price",
  "DOG_BLOCK": "dog-block",
  "DOG_OUTLINE": "dog-outline",
  "DOG": "dog",
  "DONATION_BLOCK": "donation-block",
  "DONATION_OUTLINE": "donation-outline",
  "DONATION": "donation",
  "DOWNLOAD_BLOCK": "download-block",
  "DOWNLOAD_OUTLINE": "download-outline",
  "DOWNLOAD": "download",
  "DRINK_SODA_BLOCK": "drink-soda-block",
  "DRINK_SODA_OUTLINE": "drink-soda-outline",
  "DRINK_SODA": "drink-soda",
  "E_CIGARETTE_PROHIBITED": "e-cigarette-prohibited",
  "E_CIGARETTE": "e-cigarette",
  "EDIT_BLOCK": "edit-block",
  "EDIT_OUTLINE": "edit-outline",
  "EDIT": "edit",
  "EIGHT_BLOCK": "eight-block",
  "EIGHT_OUTLINE": "eight-outline",
  "EIGHT": "eight",
  "ELECTRIC_SOCKET_BLOCK": "electric-socket-block",
  "ELECTRIC_SOCKET_OUTLINE": "electric-socket-outline",
  "ELECTRIC_SOCKET": "electric-socket",
  "EMAIL_BLOCK": "email-block",
  "EMAIL_OUTLINE": "email-outline",
  "EMAIL": "email",
  "EMPTY": "empty",
  "EXPAND_BLOCK": "expand-block",
  "EXPAND_OUTLINE": "expand-outline",
  "EXPAND": "expand",
  "EXPLOSIVES_PROHIBITED": "explosives-prohibited",
  "EXPLOSIVES": "explosives",
  "EXTERNAL_TAB_BLOCK": "external-tab-block",
  "EXTERNAL_TAB_OUTLINE": "external-tab-outline",
  "EXTERNAL_TAB": "external-tab",
  "EXTRA_CARRY_ON_BAG_BLOCK": "extra-carry-on-bag-block",
  "EXTRA_CARRY_ON_BAG_OUTLINE": "extra-carry-on-bag-outline",
  "EXTRA_CARRY_ON_BAG": "extra-carry-on-bag",
  "EXTRA_CHECK_IN_BAGGAGE_BLOCK": "extra-check-in-baggage-block",
  "EXTRA_CHECK_IN_BAGGAGE_OUTLINE": "extra-check-in-baggage-outline",
  "EXTRA_CHECK_IN_BAGGAGE": "extra-check-in-baggage",
  "EXTRA_LEG_ROOM_BLOCK": "extra-leg-room-block",
  "EXTRA_LEG_ROOM_OUTLINE": "extra-leg-room-outline",
  "EXTRA_LEG_ROOM": "extra-leg-room",
  "FACEBOOK_BLOCK": "facebook-block",
  "FACEBOOK_OUTLINE": "facebook-outline",
  "FACEBOOK": "facebook",
  "FACEMASK_BLOCK": "facemask-block",
  "FACEMASK_OUTLINE": "facemask-outline",
  "FACEMASK": "facemask",
  "FAMILY_BLOCK": "family-block",
  "FAMILY_OUTLINE": "family-outline",
  "FAMILY": "family",
  "FAVOURITE_ENTERTAINMENT_BLOCK": "favourite-entertainment-block",
  "FAVOURITE_ENTERTAINMENT_OUTLINE": "favourite-entertainment-outline",
  "FAVOURITE_ENTERTAINMENT": "favourite-entertainment",
  "FILTER_OPTIONS_BLOCK": "filter-options-block",
  "FILTER_OPTIONS_OUTLINE": "filter-options-outline",
  "FILTER_OPTIONS": "filter-options",
  "FINLAND_BLOCK": "finland-block",
  "FINLAND_OUTLINE": "finland-outline",
  "FINLAND": "finland",
  "FINNAIR_EMBLEM_BLOCK": "finnair-emblem-block",
  "FINNAIR_EMBLEM_OUTLINE": "finnair-emblem-outline",
  "FINNAIR_EMBLEM": "finnair-emblem",
  "FINNAIR_PLUS_BLOCK": "finnair-plus-block",
  "FINNAIR_PLUS_CARD_BLOCK": "finnair-plus-card-block",
  "FINNAIR_PLUS_CARD_OUTLINE": "finnair-plus-card-outline",
  "FINNAIR_PLUS_CARD": "finnair-plus-card",
  "FINNAIR_PLUS_OUTLINE": "finnair-plus-outline",
  "FINNAIR_PLUS": "finnair-plus",
  "FIRE_ARMS_PROHIBITED": "fire-arms-prohibited",
  "FIRE_ARMS": "fire-arms",
  "FIVE_BLOCK": "five-block",
  "FIVE_OUTLINE": "five-outline",
  "FIVE": "five",
  "FLAMMABLE_GASES_PROHIBITED": "flammable-gases-prohibited",
  "FLAMMABLE_GASES": "flammable-gases",
  "FLAMMABLE_LIQUIDS_PROHIBITED": "flammable-liquids-prohibited",
  "FLAMMABLE_LIQUIDS": "flammable-liquids",
  "FLAMMABLE_SOLIDS_PROHIBITED": "flammable-solids-prohibited",
  "FLAMMABLE_SOLIDS": "flammable-solids",
  "FLIGHT_CAMERA_BLOCK": "flight-camera-block",
  "FLIGHT_CAMERA_OUTLINE": "flight-camera-outline",
  "FLIGHT_CAMERA": "flight-camera",
  "FLIGHT_HOTEL": "flight-hotel",
  "FLIGHT_MAP_BLOCK": "flight-map-block",
  "FLIGHT_MAP_OUTLINE": "flight-map-outline",
  "FLIGHT_MAP": "flight-map",
  "FLIGHT_OFFER_BLOCK": "flight-offer-block",
  "FLIGHT_OFFER_OUTLINE": "flight-offer-outline",
  "FLIGHT_OFFER": "flight-offer",
  "FLIGHT_STATUS": "flight-status",
  "FLIGHTS_UNAVAILABLE_BLOCK": "flights-unavailable-block",
  "FLIGHTS_UNAVAILABLE_OUTLINE": "flights-unavailable-outline",
  "FLIGHTS_UNAVAILABLE": "flights-unavailable",
  "FOOD_BLOCK": "food-block",
  "FOOD_OUTLINE": "food-outline",
  "FOOD": "food",
  "FOUR_BLOCK": "four-block",
  "FOUR_OUTLINE": "four-outline",
  "FOUR": "four",
  "GAMES_BLOCK": "games-block",
  "GAMES_OUTLINE": "games-outline",
  "GAMES": "games",
  "GIFT_CARD_BLOCK": "gift-card-block",
  "GIFT_CARD_OUTLINE": "gift-card-outline",
  "GIFT_CARD": "gift-card",
  "GOLF_BLOCK": "golf-block",
  "GOLF_OUTLINE": "golf-outline",
  "GOLF_SKIS_BLOCK": "golf-skis-block",
  "GOLF_SKIS_OUTLINE": "golf-skis-outline",
  "GOLF_SKIS": "golf-skis",
  "GOLF": "golf",
  "GPS_LOCATION_BLOCK": "gps-location-block",
  "GPS_LOCATION_OUTLINE": "gps-location-outline",
  "GPS_LOCATION": "gps-location",
  "GROUP_BLOCK": "group-block",
  "GROUP_OUTLINE": "group-outline",
  "GROUP": "group",
  "HEADPHONES_BLOCK": "headphones-block",
  "HEADPHONES_OUTLINE": "headphones-outline",
  "HEADPHONES": "headphones",
  "HELP_BLOCK": "help-block",
  "HELP_OUTLINE": "help-outline",
  "HELP": "help",
  "HOLD_MY_BOOKING_BLOCK": "hold-my-booking-block",
  "HOLD_MY_BOOKING_OUTLINE": "hold-my-booking-outline",
  "HOLD_MY_BOOKING": "hold-my-booking",
  "HOME_BLOCK": "home-block",
  "HOME_OUTLINE": "home-outline",
  "HOME": "home",
  "HOTEL_BLOCK": "hotel-block",
  "HOTEL_OUTLINE": "hotel-outline",
  "HOTEL": "hotel",
  "IN_COMING_CALL_BLOCK": "in-coming-call-block",
  "IN_COMING_CALL_OUTLINE": "in-coming-call-outline",
  "IN_COMING_CALL": "in-coming-call",
  "INFANT_BLOCK": "infant-block",
  "INFANT_OUTLINE": "infant-outline",
  "INFANT": "infant",
  "INFO_BLOCK": "info-block",
  "INFO_OUTLINE": "info-outline",
  "INFO": "info",
  "INSTAGRAM": "instagram",
  "INSURANCE_BLOCK": "insurance-block",
  "INSURANCE_OUTLINE": "insurance-outline",
  "INSURANCE": "insurance",
  "INTERNET_DISRUPTION": "internet-disruption",
  "KEYBOARD_BLOCK": "keyboard-block",
  "KEYBOARD_OUTLINE": "keyboard-outline",
  "KEYBOARD": "keyboard",
  "LANGUAGE_BLOCK": "language-block",
  "LANGUAGE_OUTLINE": "language-outline",
  "LANGUAGE": "language",
  "LAPTOP_BLOCK": "laptop-block",
  "LAPTOP_OUTLINE": "laptop-outline",
  "LAPTOP": "laptop",
  "LAVATORY_BLOCK": "lavatory-block",
  "LAVATORY_MEN_BLOCK": "lavatory-men-block",
  "LAVATORY_MEN_OUTLINE": "lavatory-men-outline",
  "LAVATORY_MEN": "lavatory-men",
  "LAVATORY_OUTLINE": "lavatory-outline",
  "LAVATORY_WOMEN_BLOCK": "lavatory-women-block",
  "LAVATORY_WOMEN_OUTLINE": "lavatory-women-outline",
  "LAVATORY_WOMEN": "lavatory-women",
  "LAVATORY": "lavatory",
  "LEGISLATION_BLOCK": "legislation-block",
  "LEGISLATION_OUTLINE": "legislation-outline",
  "LEGISLATION": "legislation",
  "LIGHTERS_MATCHES_PROHIBITED": "lighters-matches-prohibited",
  "LIGHTERS_MATCHES": "lighters-matches",
  "LIGHTERS_PROHIBITED": "lighters-prohibited",
  "LIGHTERS": "lighters",
  "LIGHTS_OFF_BLOCK": "lights-off-block",
  "LIGHTS_OFF_OUTLINE": "lights-off-outline",
  "LIGHTS_OFF": "lights-off",
  "LIGHTS_ON_BLOCK": "lights-on-block",
  "LIGHTS_ON_OUTLINE": "lights-on-outline",
  "LIGHTS_ON": "lights-on",
  "LINK_BLOCK": "link-block",
  "LINK_OUTLINE": "link-outline",
  "LINK": "link",
  "LINKEDIN_BLOCK": "linkedin-block",
  "LINKEDIN_OUTLINE": "linkedin-outline",
  "LINKEDIN": "linkedin",
  "LIQUID_CONTAINER": "liquid-container",
  "LOCK_ACTIVE_BLOCK": "lock-active-block",
  "LOCK_ACTIVE_OUTLINE": "lock-active-outline",
  "LOCK_ACTIVE": "lock-active",
  "LOCK_CLOSED_BLOCK": "lock-closed-block",
  "LOCK_CLOSED_OUTLINE": "lock-closed-outline",
  "LOCK_CLOSED": "lock-closed",
  "LOCK_OPEN_BLOCK": "lock-open-block",
  "LOCK_OPEN_OUTLINE": "lock-open-outline",
  "LOCK_OPEN": "lock-open",
  "LOCKER_BLOCK": "locker-block",
  "LOCKER_OUTLINE": "locker-outline",
  "LOCKER": "locker",
  "LOGGED_IN_BLOCK": "logged-in-block",
  "LOGGED_IN_OUTLINE": "logged-in-outline",
  "LOGGED_IN": "logged-in",
  "LOGOUT_BLOCK": "logout-block",
  "LOGOUT_OUTLINE": "logout-outline",
  "LOGOUT": "logout",
  "LOST_BAGGAGE": "lost-baggage",
  "LOST_CARD": "lost-card",
  "LOUNGE_BLOCK": "lounge-block",
  "LOUNGE_OUTLINE": "lounge-outline",
  "LOUNGE": "lounge",
  "MAGAZINES_BLOCK": "magazines-block",
  "MAGAZINES_OUTLINE": "magazines-outline",
  "MAGAZINES": "magazines",
  "MAP_LAYERS_BLOCK": "map-layers-block",
  "MAP_LAYERS_OUTLINE": "map-layers-outline",
  "MAP_LAYERS": "map-layers",
  "MEAL_BLOCK": "meal-block",
  "MEAL_OUTLINE": "meal-outline",
  "MEAL": "meal",
  "MEDICAL_ASSISTANCE_BLOCK": "medical-assistance-block",
  "MEDICAL_ASSISTANCE_OUTLINE": "medical-assistance-outline",
  "MEDICAL_ASSISTANCE": "medical-assistance",
  "MENU_GRID_BLOCK": "menu-grid-block",
  "MENU_GRID_OUTLINE": "menu-grid-outline",
  "MENU_GRID": "menu-grid",
  "MENU_LIST_BLOCK": "menu-list-block",
  "MENU_LIST_OUTLINE": "menu-list-outline",
  "MENU_LIST_VIEW_BLOCK": "menu-list-view-block",
  "MENU_LIST_VIEW_OUTLINE": "menu-list-view-outline",
  "MENU_LIST_VIEW": "menu-list-view",
  "MENU_LIST": "menu-list",
  "MILESTONE_BLOCK": "milestone-block",
  "MILESTONE_OUTLINE": "milestone-outline",
  "MILESTONE": "milestone",
  "MINIMISE_BLOCK": "minimise-block",
  "MINIMISE_CHAT": "minimise-chat",
  "MINIMISE_OUTLINE": "minimise-outline",
  "MINIMISE": "minimise",
  "MINUS_BLOCK": "minus-block",
  "MINUS_OUTLINE": "minus-outline",
  "MINUS": "minus",
  "MMB_TICKET_CHANGES_BLOCK": "mmb-ticket-changes-block",
  "MMB_TICKET_CHANGES_OUTLINE": "mmb-ticket-changes-outline",
  "MMB_TICKET_CHANGES": "mmb-ticket-changes",
  "MOBILE_PHONE_BLOCK": "mobile-phone-block",
  "MOBILE_PHONE_OUTLINE": "mobile-phone-outline",
  "MOBILE_PHONE": "mobile-phone",
  "MORE_BLOCK": "more-block",
  "MORE_OUTLINE": "more-outline",
  "MORE": "more",
  "MOVIES_BLOCK": "movies-block",
  "MOVIES_OUTLINE": "movies-outline",
  "MOVIES": "movies",
  "MULTI_PAX_BLOCK": "multi-pax-block",
  "MULTI_PAX_OUTLINE": "multi-pax-outline",
  "MULTI_PAX": "multi-pax",
  "MULTISTOP_BLOCK": "multistop-block",
  "MULTISTOP_OUTLINE": "multistop-outline",
  "MULTISTOP": "multistop",
  "MUSIC_BLOCK": "music-block",
  "MUSIC_OUTLINE": "music-outline",
  "MUSIC": "music",
  "NIGHT_BLOCK": "night-block",
  "NIGHT_OUTLINE": "night-outline",
  "NIGHT": "night",
  "NINE_BLOCK": "nine-block",
  "NINE_OUTLINE": "nine-outline",
  "NINE": "nine",
  "NORDIC_PRODUCT_BLOCK": "nordic-product-block",
  "NORDIC_PRODUCT_OUTLINE": "nordic-product-outline",
  "NORDIC_PRODUCT": "nordic-product",
  "NOT_VISIBLE_BLOCK": "not-visible-block",
  "NOT_VISIBLE_OUTLINE": "not-visible-outline",
  "NOT_VISIBLE": "not-visible",
  "ONBOARD_SAFETY_BLOCK": "onboard-safety-block",
  "ONBOARD_SAFETY_OUTLINE": "onboard-safety-outline",
  "ONBOARD_SAFETY": "onboard-safety",
  "ONBOARD_SERVICE_BLOCK": "onboard-service-block",
  "ONBOARD_SERVICE_OUTLINE": "onboard-service-outline",
  "ONBOARD_SERVICE": "onboard-service",
  "ONE_BLOCK": "one-block",
  "ONE_OUTLINE": "one-outline",
  "ONE": "one",
  "ONEWORLD_LOGO": "oneworld-logo",
  "ONLINE_CHECKED_BLOCK": "online-checked-block",
  "ONLINE_CHECKED_OUTLINE": "online-checked-outline",
  "ONLINE_CHECKED": "online-checked",
  "PARKING": "parking",
  "PAUSE_BLOCK": "pause-block",
  "PAUSE_OUTLINE": "pause-outline",
  "PAUSE": "pause",
  "PAYMENT_METHODS_BLOCK": "payment-methods-block",
  "PAYMENT_METHODS_OUTLINE": "payment-methods-outline",
  "PAYMENT_METHODS": "payment-methods",
  "PERSON_BLOCK": "person-block",
  "PERSON_OUTLINE": "person-outline",
  "PERSON_SPECIAL_ASSIST_BLOCK": "person-special-assist-block",
  "PERSON_SPECIAL_ASSIST_OUTLINE": "person-special-assist-outline",
  "PERSON_SPECIAL_ASSIST": "person-special-assist",
  "PERSON_WALKING_BLOCK": "person-walking-block",
  "PERSON_WALKING_OUTLINE": "person-walking-outline",
  "PERSON_WALKING": "person-walking",
  "PERSON_WHEELCHAIR_BLOCK": "person-wheelchair-block",
  "PERSON_WHEELCHAIR_OUTLINE": "person-wheelchair-outline",
  "PERSON_WHEELCHAIR": "person-wheelchair",
  "PERSON": "person",
  "PET_IN_BAG_BLOCK": "pet-in-bag-block",
  "PET_IN_BAG_OUTLINE": "pet-in-bag-outline",
  "PET_IN_BAG": "pet-in-bag",
  "PET": "pet",
  "PHONE_BLOCK": "phone-block",
  "PHONE_OUTLINE": "phone-outline",
  "PHONE": "phone",
  "PICTURE_BLOCK": "picture-block",
  "PICTURE_OUTLINE": "picture-outline",
  "PICTURE": "picture",
  "PLAY_BLOCK": "play-block",
  "PLAY_NEXT_BLOCK": "play-next-block",
  "PLAY_NEXT_OUTLINE": "play-next-outline",
  "PLAY_NEXT": "play-next",
  "PLAY_OUTLINE": "play-outline",
  "PLAY_PREVIOUS_BLOCK": "play-previous-block",
  "PLAY_PREVIOUS_OUTLINE": "play-previous-outline",
  "PLAY_PREVIOUS": "play-previous",
  "PLAY": "play",
  "PLUS_BLOCK": "plus-block",
  "PLUS_OUTLINE": "plus-outline",
  "PLUS": "plus",
  "POINTS_OF_INTEREST_BLOCK": "points-of-interest-block",
  "POINTS_OF_INTEREST_OUTLINE": "points-of-interest-outline",
  "POINTS_OF_INTEREST": "points-of-interest",
  "POISON_PROHIBITED": "poison-prohibited",
  "POISON": "poison",
  "POWER_BANK_BLOCK": "power-bank-block",
  "POWER_BANK_OUTLINE": "power-bank-outline",
  "POWER_BANK_PROHIBITED": "power-bank-prohibited",
  "POWER_BANK": "power-bank",
  "POWER_BLOCK": "power-block",
  "POWER_OUTLINE": "power-outline",
  "POWER": "power",
  "PRE_ORDER_BLOCK": "pre-order-block",
  "PRE_ORDER_OUTLINE": "pre-order-outline",
  "PRE_ORDER": "pre-order",
  "PREMIUM_ECONOMY_BLOCK": "premium-economy-block",
  "PREMIUM_ECONOMY_OUTLINE": "premium-economy-outline",
  "PREMIUM_ECONOMY": "premium-economy",
  "PRICE_BLOCK": "price-block",
  "PRICE_OUTLINE": "price-outline",
  "PRICE": "price",
  "PRINT_BAG_TAG_BLOCK": "print-bag-tag-block",
  "PRINT_BAG_TAG_OUTLINE": "print-bag-tag-outline",
  "PRINT_BAG_TAG": "print-bag-tag",
  "PRIORITY_CHECK_IN_BLOCK": "priority-check-in-block",
  "PRIORITY_CHECK_IN_OUTLINE": "priority-check-in-outline",
  "PRIORITY_CHECK_IN": "priority-check-in",
  "PRIORITY_SECURITY_BLOCK": "priority-security-block",
  "PRIORITY_SECURITY_OUTLINE": "priority-security-outline",
  "PRIORITY_SECURITY": "priority-security",
  "QRCODE_BLOCK": "qrcode-block",
  "QRCODE_OUTLINE": "qrcode-outline",
  "QRCODE": "qrcode",
  "RADIO_SELECTED": "radio-selected",
  "RADIO_UNSELECTED": "radio-unselected",
  "RADIOACTIVE_PROHIBITED": "radioactive-prohibited",
  "RADIOACTIVE": "radioactive",
  "RADIOBUTTON_INVERTED_FILLED": "radiobutton-inverted-filled",
  "RE_FOCUS_BLOCK": "re-focus-block",
  "RE_FOCUS_OUTLINE": "re-focus-outline",
  "RE_FOCUS": "re-focus",
  "RENTAL_CAR_BLOCK": "rental-car-block",
  "RENTAL_CAR_OUTLINE": "rental-car-outline",
  "RENTAL_CAR": "rental-car",
  "RESERVATION_BLOCK": "reservation-block",
  "RESERVATION_OUTLINE": "reservation-outline",
  "RESERVATION": "reservation",
  "REST_BLOCK": "rest-block",
  "REST_OUTLINE": "rest-outline",
  "REST": "rest",
  "RETURN_TRIP_BLOCK": "return-trip-block",
  "RETURN_TRIP_OUTLINE": "return-trip-outline",
  "RETURN_TRIP": "return-trip",
  "RIDE_SHARE_BLOCK": "ride-share-block",
  "RIDE_SHARE_OUTLINE": "ride-share-outline",
  "RIDE_SHARE": "ride-share",
  "SAF_BLOCK": "saf-block",
  "SAF_OUTLINE": "saf-outline",
  "SAF": "saf",
  "SAVE_TIME": "save-time",
  "SCOOTER_PROHIBITED": "scooter-prohibited",
  "SCOOTER": "scooter",
  "SEAFOOD_BLOCK": "seafood-block",
  "SEAFOOD_OUTLINE": "seafood-outline",
  "SEAFOOD": "seafood",
  "SEARCH_BLOCK": "search-block",
  "SEARCH_OUTLINE": "search-outline",
  "SEARCH": "search",
  "SEAT_OR_ECONOMY_BLOCK": "seat-or-economy-block",
  "SEAT_OR_ECONOMY_OUTLINE": "seat-or-economy-outline",
  "SEAT_OR_ECONOMY": "seat-or-economy",
  "SEATBELTS_OFF_BLOCK": "seatbelts-off-block",
  "SEATBELTS_OFF_OUTLINE": "seatbelts-off-outline",
  "SEATBELTS_OFF": "seatbelts-off",
  "SEATBELTS_ON_BLOCK": "seatbelts-on-block",
  "SEATBELTS_ON_OUTLINE": "seatbelts-on-outline",
  "SEATBELTS_ON": "seatbelts-on",
  "SECURE_PAYMENT_BLOCK": "secure-payment-block",
  "SECURE_PAYMENT_OUTLINE": "secure-payment-outline",
  "SECURE_PAYMENT": "secure-payment",
  "SECURITY_BLOCK": "security-block",
  "SECURITY_OUTLINE": "security-outline",
  "SECURITY": "security",
  "SERVICE_DESK_BLOCK": "service-desk-block",
  "SERVICE_DESK_OUTLINE": "service-desk-outline",
  "SERVICE_DESK": "service-desk",
  "SETTINGS_BLOCK": "settings-block",
  "SETTINGS_OUTLINE": "settings-outline",
  "SETTINGS": "settings",
  "SEVEN_BLOCK": "seven-block",
  "SEVEN_OUTLINE": "seven-outline",
  "SEVEN": "seven",
  "SHARE_ANDROID_BLOCK": "share-android-block",
  "SHARE_ANDROID_OUTLINE": "share-android-outline",
  "SHARE_ANDROID": "share-android",
  "SHARP_OBJECTS_PROHIBITED": "sharp-objects-prohibited",
  "SHARP_OBJECTS": "sharp-objects",
  "SHOPPING_CART_ACTIVE": "shopping-cart-active",
  "SHOPPING_CART_BLOCK": "shopping-cart-block",
  "SHOPPING_CART_OUTLINE": "shopping-cart-outline",
  "SHOPPING_CART": "shopping-cart",
  "SHOWER_BLOCK": "shower-block",
  "SHOWER_OUTLINE": "shower-outline",
  "SHOWER": "shower",
  "SINGLE_PAX_BLOCK": "single-pax-block",
  "SINGLE_PAX_OUTLINE": "single-pax-outline",
  "SINGLE_PAX": "single-pax",
  "SIX_BLOCK": "six-block",
  "SIX_OUTLINE": "six-outline",
  "SIX": "six",
  "SKIP_15S_BACK_BLOCK": "skip-15s-back-block",
  "SKIP_15S_BACK_OUTLINE": "skip-15s-back-outline",
  "SKIP_15S_BACK": "skip-15s-back",
  "SKIP_15S_FORWARD_BLOCK": "skip-15s-forward-block",
  "SKIP_15S_FORWARD_OUTLINE": "skip-15s-forward-outline",
  "SKIP_15S_FORWARD": "skip-15s-forward",
  "SKIS_BLOCK": "skis-block",
  "SKIS_OUTLINE": "skis-outline",
  "SKIS": "skis",
  "SMOKING_BLOCK": "smoking-block",
  "SMOKING_OUTLINE": "smoking-outline",
  "SMOKING_PROHIBITED": "smoking-prohibited",
  "SMOKING": "smoking",
  "SNACKS_BLOCK": "snacks-block",
  "SNACKS_OUTLINE": "snacks-outline",
  "SNACKS": "snacks",
  "SORT_ASCENDING_BLOCK": "sort-ascending-block",
  "SORT_ASCENDING_OUTLINE": "sort-ascending-outline",
  "SORT_ASCENDING": "sort-ascending",
  "SORT_BLOCK": "sort-block",
  "SORT_DESCENDING_BLOCK": "sort-descending-block",
  "SORT_DESCENDING_OUTLINE": "sort-descending-outline",
  "SORT_DESCENDING": "sort-descending",
  "SORT_OUTLINE": "sort-outline",
  "SORT": "sort",
  "SPARE_LITHIUM_BATTERIES": "spare-lithium-batteries",
  "SPARKLING_WINE_BLOCK": "sparkling-wine-block",
  "SPARKLING_WINE_GLASS_BLOCK": "sparkling-wine-glass-block",
  "SPARKLING_WINE_GLASS_OUTLINE": "sparkling-wine-glass-outline",
  "SPARKLING_WINE_GLASS": "sparkling-wine-glass",
  "SPARKLING_WINE_OUTLINE": "sparkling-wine-outline",
  "SPARKLING_WINE": "sparkling-wine",
  "SPORTS_EQUIPMENT_BLOCK": "sports-equipment-block",
  "SPORTS_EQUIPMENT_OUTLINE": "sports-equipment-outline",
  "SPORTS_EQUIPMENT": "sports-equipment",
  "STAR_BLOCK": "star-block",
  "STAR_OUTLINE": "star-outline",
  "STAR": "star",
  "STOPOVER_BLOCK": "stopover-block",
  "STOPOVER_OUTLINE": "stopover-outline",
  "STOPOVER": "stopover",
  "SUBTITLES_BLOCK": "subtitles-block",
  "SUBTITLES_OUTLINE": "subtitles-outline",
  "SUBTITLES": "subtitles",
  "SURFBOARD_BLOCK": "surfboard-block",
  "SURFBOARD_OUTLINE": "surfboard-outline",
  "SURFBOARD": "surfboard",
  "SUSTAINABILITY_BLOCK": "sustainability-block",
  "SUSTAINABILITY_OUTLINE": "sustainability-outline",
  "SUSTAINABILITY": "sustainability",
  "SWITCH_FLIGHTS_BLOCK": "switch-flights-block",
  "SWITCH_FLIGHTS_OUTLINE": "switch-flights-outline",
  "SWITCH_FLIGHTS": "switch-flights",
  "TABLET_BLOCK": "tablet-block",
  "TABLET_OUTLINE": "tablet-outline",
  "TABLET": "tablet",
  "TAIL_BLOCK": "tail-block",
  "TAIL_OUTLINE": "tail-outline",
  "TAIL": "tail",
  "TAXI_BLOCK": "taxi-block",
  "TAXI_OUTLINE": "taxi-outline",
  "TAXI": "taxi",
  "TAZER_PROHIBITED": "tazer-prohibited",
  "TAZER": "tazer",
  "TEA_BLOCK": "tea-block",
  "TEA_OUTLINE": "tea-outline",
  "TEA": "tea",
  "THREE_BLOCK": "three-block",
  "THREE_OUTLINE": "three-outline",
  "THREE": "three",
  "TICKET_REFUND_BLOCK": "ticket-refund-block",
  "TICKET_REFUND_OUTLINE": "ticket-refund-outline",
  "TICKET_REFUND": "ticket-refund",
  "TIER_POINTS_BLOCK": "tier-points-block",
  "TIER_POINTS_OUTLINE": "tier-points-outline",
  "TIER_POINTS": "tier-points",
  "TIER_PROGRESS_BLOCK": "tier-progress-block",
  "TIER_PROGRESS_OUTLINE": "tier-progress-outline",
  "TIER_PROGRESS": "tier-progress",
  "TIKTOK_BLOCK": "tiktok-block",
  "TIKTOK_OUTLINE": "tiktok-outline",
  "TIKTOK": "tiktok",
  "TIME_ZONE_BLOCK": "time-zone-block",
  "TIME_ZONE_OUTLINE": "time-zone-outline",
  "TIME_ZONE": "time-zone",
  "TIMETABLE": "timetable",
  "TOOLS_AND_BLUNT_INSTRUMENTS_PROHIBITED": "tools-and-blunt-instruments-prohibited",
  "TOOLS_AND_BLUNT_INSTRUMENTS": "tools-and-blunt-instruments",
  "TRACK_PLAYING_BLOCK": "track-playing-block",
  "TRACK_PLAYING_OUTLINE": "track-playing-outline",
  "TRACK_PLAYING": "track-playing",
  "TRAIN_BLOCK": "train-block",
  "TRAIN_OUTLINE": "train-outline",
  "TRAIN": "train",
  "TRANSFER_LOADER_BLOCK": "transfer-loader-block",
  "TRANSFER_LOADER_OUTLINE": "transfer-loader-outline",
  "TRANSFER_LOADER": "transfer-loader",
  "TRASH_BLOCK": "trash-block",
  "TRASH_OUTLINE": "trash-outline",
  "TRASH": "trash",
  "TRAVEL_DOCUMENTS_BLOCK": "travel-documents-block",
  "TRAVEL_DOCUMENTS_OUTLINE": "travel-documents-outline",
  "TRAVEL_DOCUMENTS": "travel-documents",
  "TRAVEL_INSURANCE_BLOCK": "travel-insurance-block",
  "TRAVEL_INSURANCE_OUTLINE": "travel-insurance-outline",
  "TRAVEL_INSURANCE": "travel-insurance",
  "TREATS_BLOCK": "treats-block",
  "TREATS_OUTLINE": "treats-outline",
  "TREATS": "treats",
  "TRENDING_ARROW_UP": "trending-arrow-up",
  "TWENTY_FOUR_HOUR_REFUND_BLOCK": "twenty-four-hour-refund-block",
  "TWENTY_FOUR_HOUR_REFUND_OUTLINE": "twenty-four-hour-refund-outline",
  "TWENTY_FOUR_HOUR_REFUND": "twenty-four-hour-refund",
  "TWITTER": "twitter",
  "TWO_BLOCK": "two-block",
  "TWO_OUTLINE": "two-outline",
  "TWO": "two",
  "UPDATE_BLOCK": "update-block",
  "UPDATE_CART_BLOCK": "update-cart-block",
  "UPDATE_CART_OUTLINE": "update-cart-outline",
  "UPDATE_CART": "update-cart",
  "UPDATE_OUTLINE": "update-outline",
  "UPDATE": "update",
  "UPGRADE_BLOCK": "upgrade-block",
  "UPGRADE_OUTLINE": "upgrade-outline",
  "UPGRADE": "upgrade",
  "UPLOAD_BLOCK": "upload-block",
  "UPLOAD_OUTLINE": "upload-outline",
  "UPLOAD": "upload",
  "VAT_RECEIPT_DOWNLOAD_BLOCK": "vat-receipt-download-block",
  "VAT_RECEIPT_DOWNLOAD_OUTLINE": "vat-receipt-download-outline",
  "VAT_RECEIPT_DOWNLOAD": "vat-receipt-download",
  "VIDEO_SERIES_BLOCK": "video-series-block",
  "VIDEO_SERIES_OUTLINE": "video-series-outline",
  "VIDEO_SERIES": "video-series",
  "VISIBLE_BLOCK": "visible-block",
  "VISIBLE_OUTLINE": "visible-outline",
  "VISIBLE": "visible",
  "VOLUME_BLOCK": "volume-block",
  "VOLUME_LOW_BLOCK": "volume-low-block",
  "VOLUME_LOW_OUTLINE": "volume-low-outline",
  "VOLUME_LOW": "volume-low",
  "VOLUME_MEDIUM_BLOCK": "volume-medium-block",
  "VOLUME_MEDIUM_OUTLINE": "volume-medium-outline",
  "VOLUME_MEDIUM": "volume-medium",
  "VOLUME_MUTE_BLOCK": "volume-mute-block",
  "VOLUME_MUTE_OUTLINE": "volume-mute-outline",
  "VOLUME_MUTE": "volume-mute",
  "VOLUME_OUTLINE": "volume-outline",
  "VOLUME": "volume",
  "VOUCHER_BLOCK": "voucher-block",
  "VOUCHER_OUTLINE": "voucher-outline",
  "VOUCHER": "voucher",
  "WALLET_CLOSED_BLOCK": "wallet-closed-block",
  "WALLET_CLOSED_OUTLINE": "wallet-closed-outline",
  "WALLET_CLOSED": "wallet-closed",
  "WALLET_OPEN_BLOCK": "wallet-open-block",
  "WALLET_OPEN_OUTLINE": "wallet-open-outline",
  "WALLET_OPEN": "wallet-open",
  "WATER_BLOCK": "water-block",
  "WATER_OUTLINE": "water-outline",
  "WATER": "water",
  "WECHAT": "wechat",
  "WEIBO": "weibo",
  "WELLBEING_BLOCK": "wellbeing-block",
  "WELLBEING_OUTLINE": "wellbeing-outline",
  "WELLBEING": "wellbeing",
  "WHATSAPP_BLOCK": "whatsapp-block",
  "WHATSAPP_OUTLINE": "whatsapp-outline",
  "WHATSAPP": "whatsapp",
  "WIFI_AIRCRAFT": "wifi-aircraft",
  "WIFI_BLOCK": "wifi-block",
  "WIFI_LOW_BLOCK": "wifi-low-block",
  "WIFI_LOW_OUTLINE": "wifi-low-outline",
  "WIFI_LOW": "wifi-low",
  "WIFI_MEDIUM_BLOCK": "wifi-medium-block",
  "WIFI_MEDIUM_OUTLINE": "wifi-medium-outline",
  "WIFI_MEDIUM": "wifi-medium",
  "WIFI_OFFLINE_BLOCK": "wifi-offline-block",
  "WIFI_OFFLINE_OUTLINE": "wifi-offline-outline",
  "WIFI_OFFLINE": "wifi-offline",
  "WIFI_OUTLINE": "wifi-outline",
  "WIFI": "wifi",
  "WINE_BLOCK": "wine-block",
  "WINE_GLASS_BLOCK": "wine-glass-block",
  "WINE_GLASS_OUTLINE": "wine-glass-outline",
  "WINE_GLASS": "wine-glass",
  "WINE_OUTLINE": "wine-outline",
  "WINE": "wine",
  "WORLD_MAP_BLOCK": "world-map-block",
  "WORLD_MAP_OUTLINE": "world-map-outline",
  "WORLD_MAP": "world-map",
  "X_BLOCK": "x-block",
  "X_OUTLINE": "x-outline",
  "X": "x",
  "YOUKU": "youku",
  "YOUTUBE": "youtube",
  "ZERO_BLOCK": "zero-block",
  "ZERO_OUTLINE": "zero-outline",
  "ZERO": "zero"
};

module.exports.TailsIcon = {
  "TAIL_3K": "tail_3k",
  "TAIL_6I": "tail_6i",
  "TAIL_9W": "tail_9w",
  "TAIL_A3": "tail_a3",
  "TAIL_AA": "tail_aa",
  "TAIL_AB": "tail_ab",
  "TAIL_AF": "tail_af",
  "TAIL_AI": "tail_ai",
  "TAIL_AS": "tail_as",
  "TAIL_AT": "tail_at",
  "TAIL_AY": "tail_ay",
  "TAIL_AZ": "tail_az",
  "TAIL_B6": "tail_b6",
  "TAIL_BA": "tail_ba",
  "TAIL_BR": "tail_br",
  "TAIL_BT": "tail_bt",
  "TAIL_BUS": "tail_bus",
  "TAIL_CA": "tail_ca",
  "TAIL_CI": "tail_ci",
  "TAIL_CX": "tail_cx",
  "TAIL_CZ": "tail_cz",
  "TAIL_DX": "tail_dx",
  "TAIL_EI": "tail_ei",
  "TAIL_EK": "tail_ek",
  "TAIL_ET": "tail_et",
  "TAIL_FI": "tail_fi",
  "TAIL_FJ": "tail_fj",
  "TAIL_GA": "tail_ga",
  "TAIL_GL": "tail_gl",
  "TAIL_HO": "tail_ho",
  "TAIL_HU": "tail_hu",
  "TAIL_IB": "tail_ib",
  "TAIL_IG": "tail_ig",
  "TAIL_IJ": "tail_ij",
  "TAIL_JL": "tail_jl",
  "TAIL_JP": "tail_jp",
  "TAIL_JU": "tail_ju",
  "TAIL_KA": "tail_ka",
  "TAIL_KE": "tail_ke",
  "TAIL_KL": "tail_kl",
  "TAIL_KM": "tail_km",
  "TAIL_LA": "tail_la",
  "TAIL_LG": "tail_lg",
  "TAIL_LH": "tail_lh",
  "TAIL_LM": "tail_lm",
  "TAIL_LO": "tail_lo",
  "TAIL_LX": "tail_lx",
  "TAIL_MH": "tail_mh",
  "TAIL_MI": "tail_mi",
  "TAIL_MU": "tail_mu",
  "TAIL_NT": "tail_nt",
  "TAIL_NZ": "tail_nz",
  "TAIL_OK": "tail_ok",
  "TAIL_OO": "tail_oo",
  "TAIL_OS": "tail_os",
  "TAIL_OU": "tail_ou",
  "TAIL_OZ": "tail_oz",
  "TAIL_PG": "tail_pg",
  "TAIL_PR": "tail_pr",
  "TAIL_PS": "tail_ps",
  "TAIL_QF": "tail_qf",
  "TAIL_QR": "tail_qr",
  "TAIL_RJ": "tail_rj",
  "TAIL_S7": "tail_s7",
  "TAIL_SB": "tail_sb",
  "TAIL_SK": "tail_sk",
  "TAIL_SN": "tail_sn",
  "TAIL_SQ": "tail_sq",
  "TAIL_SU": "tail_su",
  "TAIL_SV": "tail_sv",
  "TAIL_TF": "tail_tf",
  "TAIL_TG": "tail_tg",
  "TAIL_TK": "tail_tk",
  "TAIL_TN": "tail_tn",
  "TAIL_TP": "tail_tp",
  "TAIL_TRN": "tail_trn",
  "TAIL_UK": "tail_uk",
  "TAIL_UL": "tail_ul",
  "TAIL_VN": "tail_vn",
  "TAIL_WF": "tail_wf",
  "TAIL_WY": "tail_wy"
};module.exports.IconLibrary = {
  "CUSTOM": "custom",
  "PAYMENTS": "payments",
  "SVG_LIBRARY": "svg-library",
  "TAILS": "tails"
};